const decodeJwtPayload = (token) => {
  try {
    if (!token || typeof token !== "string") return null
    const parts = token.split(".")
    if (parts.length < 2) return null
    const base64Url = parts[1]
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4)
    const json = atob(padded)
    return JSON.parse(json)
  } catch (_) {
    return null
  }
}

export const getImpersonationPayload = (token = "") => {
  if (token && typeof token === "object") return token?.impersonation || null
  const sourceToken =
    typeof token === "string" && token.trim()
      ? token
      : (typeof window !== "undefined" ? localStorage.getItem("token") || "" : "")
  const payload = decodeJwtPayload(sourceToken)
  return payload?.impersonation && typeof payload.impersonation === "object"
    ? payload.impersonation
    : null
}

export const getGroupScopedImpersonation = (token = "") => {
  const impersonation = getImpersonationPayload(token)
  if (!impersonation) return null
  const scope = String(impersonation?.scope || "").toLowerCase()
  const groupId = String(impersonation?.groupId || "").trim()
  if (scope !== "group" || !groupId) return null
  return {
    scope,
    groupId,
    groupName: String(impersonation?.groupName || "").trim(),
    impersonatorId: String(impersonation?.impersonatorId || "").trim(),
    impersonatedUserId: String(impersonation?.impersonatedUserId || "").trim(),
    mode: String(impersonation?.mode || "").trim(),
  }
}

export const isGroupScopedImpersonationActive = (token = "") => {
  return !!getGroupScopedImpersonation(token)
}
